import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    width={210.2}
    height={317.4}
    viewBox="0 0 210.2 317.4"
    {...props}
  >
    <defs>
      <style>
        {
          "\n      .attentive-cls-1 {\n        fill: #5b4848;\n      }\n\n      .attentive-cls-2 {\n        fill: #c88242;\n      }\n\n      .attentive-cls-3 {\n        fill: #f5f0e8;\n      }\n\n      .attentive-cls-4 {\n        fill: none;\n        stroke: #5b4848;\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n    "
        }
      </style>
    </defs>
    <g id="Layer_2-2" data-name="Layer 2">
      <circle className="attentive-cls-4" cx={105.1} cy={212.3} r={100.1} />
      <path
        className="attentive-cls-2"
        d="M147.3,259.8c-1.6-4.1-7.1-19.4-10.4-24.9s-7.4-24.7-4.6-31.1,8-16.7,28.2-26,35.2-6.7,36.9-30.4c1.5-20.3-23.6-26.6-29.2-27.3s-112.3,9-149.4,26-7.4,45.8,2.8,47.3c18.5,2.7,32-2.3,42,10.4s9.8,28.5,7.5,41.8-13.1,32.1-13.1,32.1l-7.9,12.2s55,41.9,114.7-3.6c0,0-12.6-14-17.5-26.6Z"
      />
      <path
        className="attentive-cls-2"
        d="M23.5,72.9c6.6,7.9,28.5,21.5,28.5,21.5,0,0,29,1.4,35,14.5s21.7,1.6,24.1-3.6,9.1-21.9,15.3-24.6-.4-3.5,18.2-3.7,45.3-27.2,40.3-27.9-10,3.8-16.2,6.3-13.1,3.2-20.5-2.6-16.3-8.1-27.3-7.7-21.3,11.9-16.5,32.1c0,0-18.5,0-26,3.3l-7.4-15.2c-4.1-9.2-6.8-22.8-12.4-29.5s-8.6-7.2-16.5-9.3c-14.7-4-18.7-10.3-22.5-15.1S4.8-8.1,7.3,7.9-2.4,41.8,23.5,72.9Z"
      />
      <path
        className="attentive-cls-1"
        d="M41.2,26c-1.4-.5-3-.6-4.3-1.6-.1-.1-.4-.1-.6-.2l-.6-.2-.6-.2-.6-.3c-.7-.6-1.7-1.1-2.7-1,.7.6.1,1.3-.6.4-.4,0-.4-.5,0-.6-.3-.5-.9-1-1.6-1.3-3.3-1.4-5.3-4.7-7.8-7.1C16.8,9.1,13.9,1.8,9.2,0s-4.4,3.8-3.8,5.5l1.3-1.5.4.2c-.9,3,.3,7.5-.9,10.5,0,.3.3.8.6.9.4.2.5.5.6.7,0,.6-.2,1.1-.5,1.4l1.2,2.8c-.4.2-.5.4-.5.9.6,4.7,4.4,11.8,5.9,11.7.5,0,1.1-1,1.5-1.4l3.4,1.8c.9.5,2.3-.3,3.4,0,1.6.4,3-.9,4.4-1.2,5.3-1.4,5.8-3.7,9.3-6.5,2,.4,4,.7,5.7,0Z"
      />
      <path
        className="attentive-cls-1"
        d="M176.2,61.3c-.3.5-1.1.3-1,.8l-.5.4c-2.9,2.3-6.3.1-5.7-.5l-.8.9c-3.3-.3-6.3,3.7-8.7,1.6l-4.5-2.1c-.8-.7-2.7-4.7-3.4-4.8-.7-1-1.5-2.2-2.3-3,0,0-.5-.5-3-2.8,1.9.4,4.6,2,4.6,2l6.8,3.2c4.5,1.2,10-1.2,13.3-2.9,6.6-3.3,8.8-6.5,15.7-4.8-.2.6-1.5-.2-1.8-.3s0,.4.1.5l.6.4c.4.3.5.7.4,1-.1.4-1.1,2.2-1.6,2.1,0,0-3.4,2.3-5.1,5.4-.4.8-1.6.2-1.8.9,0,0-.7.7-1.3,1.8Z"
      />
      <g>
        <path
          className="attentive-cls-1"
          d="M63.6,87.6s-4.9,1.1-6.5.9-2.2,0-2.7,1c0,0-9.5,3.5-13.5,7.2s-19.2,18.8-10.3,44.6c0,0,6.2,16,25.1,18.6,0,0-2.2.9-2,1.5s5.4,1.3,7.9,3.5,14.4-2.3,17.5-6.3,25.7-15.5,10.9-51.3c0,0-1.2.2-2.2-1.6s-6.4-16.3-24.3-18.2Z"
        />
        <path
          className="attentive-cls-3"
          d="M43.7,133.3c-2.3-13.1,4.6-26.5,17.2-28.6,3.6-.6,8.3-.8,11.3,1.8,6.5,5.7,8.2,14.4,6.8,22.7-1.5,8.8-7.1,16-15.7,19.1"
        />
        <path className="attentive-cls-3" d="M63.4,148.2c-8.5,3-18.2-6.5-19.7-14.9" />
      </g>
      <path
        className="attentive-cls-1"
        d="M108.6,93.9l-3,.3s-.9,1.7-1.6,2.5v3.3c0,0-2.3,2.1-2.3,2.1,0,0-7.6,16.1,2.8,36.4s27,17.4,29.5,16.6,3-2.1,3.6-2.4,2,0,3,.2,3.1-1,3.7-2.5,7.2.7,13.9-10.3c0,0,0-.5,1.7-1.8s12.6-12.9,10.3-28.5-13.1-30.5-31-35.2-29.6,14.4-30.5,19.3Z"
      />
      <path
        className="attentive-cls-3"
        d="M119.1,124.3l2.3,4.3c.2-.1.6-.1.8,0s.1.7.3,1c1.8,3.2,5.1,5.1,8.7,6.7,5.5,2.5,11.9,1.5,16.9-1.6-1.3-.7-1.9.6-2.9.5,3.8-2.9,6.6-7,7.4-11.8s-.3-1.6.9-2c.6-4.7.3-9.5-1.8-13.9l-2.5-5.2-4.1-4.5c-1.1-1.2-2.5-2.1-3.9-2.9-5.3-3.4-11.6-3.7-17.4-1.1-6.8,5.6-9.8,14.1-7.4,22.7.2.6-.6,2,.9,2.3l1.8,5.6Z"
      />
      <g>
        <path
          className="attentive-cls-3"
          d="M84.6,144.5c1.4-.7,2.8-1.3,4.3-1.6,3.3.4,6.6.6,10,.6.4,0,.7,0,1.1,0,1.1.4,3.1-.3,3.7,1.1-1.3-.7-1.6.9-.4.6,2.3.1,4.1,1.7,6.3,2.6.3.1,0,.7-.6.7"
        />
        <path
          className="attentive-cls-3"
          d="M87.3,190.4c-7.3,6.4-20.3,1.4-20.3,1.4-4.3,1.6-7-2.7-9.2-2.9-1.6-.1-2.2,0-3.7-1.1l-3.8-1.7-8.2.3c-2.6.3-5,1-7.7,0,1.7-1.1,3.2-.4,4.6-.7-.3-.6-.7-.5-1-.6l-16.5-4.4,1.2-5.5c-.8-.4-1.2-2.4-.9-3.1l1.3-3.3c1.9,0,3.4-1.1,5.1-1.6,1.6-.4,2.6-.6,3.9-2.6l.6,2,1.1-3.1c.6.9.6,1.6,1,1.9.3.3,4.9.5,9,2.5.5.3,1.1,1.6,2,1.5.5,0,1.5-1,2-.9,1.7.4,3.7,1.1,5.5.6.6.4.8,1.6.9,2.4,2.5-.6,3.1-2.6,4.4-4.3l3.4-4.3c4.5-5.7,11.3-7.3,14.5-12.6s9.5-8.1,9.5-8.1c-.3-.5,1.4-1.2,1.8-1.6,4-3.3,3.9-8.3,4.1-13.3.2-6.3-3.4-10.2-4.7-16.3-.2-.1,1.1-2.4,1-2.8-1.2-4.7-3-8.8-3.5-13.6-.3-3.2,1-3.6,3.7-5.9,1.4-1.2,2.6-5.7,4-4.2,1.2,1.3,1.9,3.3,2.5,5,1.5,3.8,3.1,7.5,3.7,11.5.3,1.9-.2,4.1,0,6,.2,1.7.2,3.5-.6,5.1,0,.9.1,1.8.2,2.7,0,0,0,0,0,0,0,.2.9.5.8.7,0,.2-.8.4-.8.6.5,7.8,3.4,15.4,6.3,22.6.5,1.1,3.2,3,3.9,3.6,1.4.6,2.9,2.3,4.2,3.2l2.8,4.1c5.7,2.7,11.1,5.4,15.7,9.6l4.3,3.9,2.1-4.7c.9-2.1,5.8-2.5,6.8-.3,0,1.3-1.1,3.4.6,4.4.6-.7,1.7-2,2.7-1.8.7.2,1.4,1.8,2.7,1.7.3-.4.5-1.2,1.2-1.5,2.4,1.9,2.5-1.2,5.7-1.5l1.4-3.1c.7,1.3,1.4,1.6,2.3,1.7,1.1.1,2.2.2,2.5-1.1.2-.8,0-2,.6-2.6.6-.5,3.5-1.7,4.8-1.2.7.2,1,1,1.2,1.9,1.6-1,3.6-1.9,5.1-1.3.6.5,1,1.9,2,2.1,0,3.5,2.1,6,4.9,7.9-.5,1.6-1.7,3.6-3.3,3.8l-5.3.4-4,1.4-3.6,2-8.8,2.1c-.9.2-1.5,1.1-2.4.9-.5-.1-1.5.6-2,1-1,.8-2.1.2-2.8,0-2.7-.4-5.1,1.7-6.8,3.9l-2.4,2.1c-.8,1.5-1.1,2.9-2.5,4-1.8,1.2-1.4,2.5-2.7,3.3-2.2,1.5-4.7,2.3-7,3.2,0,0-6.4,4-14.8,1s-17.4,1.9-26.5-2.2Z"
        />
      </g>
      <path
        className="attentive-cls-1"
        d="M113.8,192.5c-.5-.1-1.1-.3-1.6-.4h1.5c-4.7-1-9.6-2.3-12.9-6.1-.6-.7-1.1-1.9-1.5-3.1-.3-1.3-.5-2.6-.4-3.6.3-2.9,0-4.7-.4-7.5l-1-5.5.8-5.7,7.1-4.7,4.4-4.7c.5-.5.5-1.3.3-1.7,0,0,0,0,0,0,0,0,0-.1,0-.2-.2-.5-.6-.8-1.1-1,.3-.2.4-.5.2-.6,0-.1,0-.2,0-.3-2.1-1-3.9-2.5-6.2-2.6-.3,0-.5,0-.6-.1,0-.3.4-.6,1.1-.2,0-.1-.1-.2-.2-.3,0,0,0,0,.1,0-.6-1.5-2.6-.7-3.7-1.1-5.2-1.8-10.3-1.4-15.3,1.1-2.2,1.1-4.4,2.3-6.3,3.7,0,1.1-.7,2.5-.3,3.7,0,.2,0,.4.2.5,1.8,3.5,4.9,5.2,8.1,6.9,2.7,1.5,5,3.4,8.5,3.6l.2,8.3c0,1.2-.7,2.1-2.1,2.1.3,1.4.4,2.6.2,4-1.3,6.6,2,8.5-2.2,11l-3.4,2h.5s-.4.3-.4.3c-1.8,1-3.3,1.7-5,2.7-2.8,1.6-11.8-.5-6.7,3.4,1,.8,2.1,1,3.5,1.4.7.3,1.4.5,1.7.6,3.9,1.9,8.2,1.8,12.4,1,3,.7,5.9.7,8.7-.4l5.4-.3c1.6-.1,2.8-.4,4.1-.9.7-.2,2-.4,3.1-.4l3.6-.9,3.1-1.2,3.5-.5,3.1-2.5c-3,0-5.8,2.3-14,.4ZM91.7,156.4c.2.3.4.6.6,1,0,.1,0,.2,0,.3-.2.3-.9.3-1.1.1,0-.7.3-1.2.6-1.4ZM83.7,154.3c3.5-.9,3.8,3.6,5.6,1.2.1,0,.3,0,.4.3,0,.2,0,.3,0,.5-.7,1.3-4.4.5-5.9-1.9Z"
      />
      <g>
        <path
          className="attentive-cls-1"
          d="M73.3,170.1c0,.8-.6,1.3-1.1,1.4s-1.5,0-1.8-.7-.2-1.4.4-1.9,1.2-.5,1.8-.3.8.9.7,1.6Z"
        />
        <path
          className="attentive-cls-1"
          d="M82.8,171.4c.3,1.2-.8,3.9-2.2,3.9-2.3,0-3.6-3.2-2.4-4.9.6-.9,1.6-1.1,2.5-.9s1.7.4,2,1.9Z"
        />
        <path
          className="attentive-cls-1"
          d="M86.3,180.2c-.6.8-2.9,1.2-3.6.4-1-1.1-.5-3.4.7-4.1s2.5-.4,3.1.4.8,2-.2,3.3Z"
        />
        <path
          className="attentive-cls-1"
          d="M81.4,185c.2,1.3-1.1,2.1-1.9,2.2-1.4.2-2.8-.2-2.9-1.8s1.1-2.1,2.1-2.1,2.6.4,2.8,1.7Z"
        />
        <path
          className="attentive-cls-1"
          d="M76.1,178.2c-.1-.8-.8-.8-1.1-1-.7-.5-1.1-.9-1.8-.8-1,0-1.2.9-1.7,1.7-.6,1.1,0,1.9.4,2.5.9,1.2,2.1,1,3,.6,1.2-.5,1.5-1.7,1.3-2.9Z"
        />
        <path
          className="attentive-cls-1"
          d="M105.7,167.9c1-1,2.5-.6,3.5,0,1,.6,1.9,2,1.2,3.5-.9,1.9-2.9,1.2-4.1,0-1-1-1.8-2.5-.6-3.6Z"
        />
        <path
          className="attentive-cls-1"
          d="M110.5,183.7c-1,0-2-.2-2.7-.8-.5-.4-1.2-1.4-.6-2.4.7-1.2,5.5-.3,5.6,1.5,0,1.3-1,1.7-2.3,1.7Z"
        />
        <path
          className="attentive-cls-1"
          d="M117.8,167.5c.3-.9,1.2-1.3,2-1.3,1,0,2,.7,2.1,2.2,0,1.1-.3,1.9-1,2.2-.7.3-1.5,0-2.2-.7-.7-.7-1.2-1.5-.9-2.4Z"
        />
        <path
          className="attentive-cls-1"
          d="M113.9,176.6c-.7-.9-.9-2.8-.5-3.8.8-1.5,2.6-1,3.4-.4,1.3.9,1.4,2.5.5,3.7-.7.9-2.6,1.7-3.5.5Z"
        />
        <path
          className="attentive-cls-1"
          d="M123.6,180.9c-1.8,1.1-4.3-1.8-3.8-3.1.3-.8,1.2-1.2,1.8-1.3.9,0,1.8.3,2.5,1.3.8,1.2.4,2.5-.6,3.1Z"
        />
      </g>
      <path
        className="attentive-cls-3"
        d="M169.7,120.4l7.9,1.9c7.1,2.1,11.5,5.4,15.9,11.1s3.4,6.2,3.8,10.2c-1.4.3-2.9-.3-4.2-.6-2.8-.8-3.5,3.5-4.9,3.2s-2.1-5.3-4.9-6.5-5-2.7-5.1-6.1c-1.5.6-3.1.9-4.3,1.8l.5,1.7c.3,1-2.4.8-2.3,2.2,0,.7.4.9,1.3,1.1s.3,1.1,0,1.4c-.6.7-2.2.6-3.9,0,.2-1.5-.2-2.4-1.7-3.2,1.1-.8,1.8-1.8,1.6-2.8s-1-2.3-2-2.1c-1.7.3-2.5.6-3.9.4,0,0,4.2-5.3,6.1-13.6ZM176.6,133.1c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5Z"
      />
      <path
        className="attentive-cls-3"
        d="M37.3,150.9c0,0-1.4.8-1.6,1.2-2.3-.9-4.3-.1-6.1,1-1.6,0-4.7-1.7-6.3-.6s-3.4,1.1-4.9,2-2.6,1.7-4.6,2.4l-12.2,4.7c.5-2.5,2.3-6.1,6.1-9.5s7.7-5,9.8-6c3.8-1.9,8.6-4,12.9-4.7,1.6,3.6,4.3,7.2,6.8,9.6Z"
      />
      <path
        className="attentive-cls-3"
        d="M122.9,295.6c-.6,1.4-.8,2.5-1.5,3-.5.3-1.8.1-2.2-.4-.3-.5.4-1.6.3-2.2-1.1-4,2.3-7.9-1.1-10.2-1.5-1-3.6,1.7-4.8,1.6-1.8-.2,1.1-2,.4-3.9,2-2.6,3.9-5.5,2.6-9.1,1.2-.4,2.6-1.1,2.4-2.4-.6,0-2.5-.7-1.9-1.8.4-.5,2.5-1,1.7-2.2-.4-.4-1.4-1.3-1-1.8.2-.3,1.1-.9,1.1-1.5-.4-4.7,2.9-2.7,4.8-6.5.4,1.8.3,3.4,2.2,3.7.1-1.9.8-4.1,0-5.6-.6-1.1-3.9-.3-4,.8,0,1,.6,2-.1,2.4-.8.4-2,.9-2.6.2l-1.9-2.3c2.4-3,6-2.2,5.2-4.5-.2-.5-1.2-.7-1.5-.3l-.9.8c-1.7,1.7-4.4,1.5-6.6,1.1-.3,0-1,.9-.8,1l1.3.6c.1,1.4-.9.6-1.4.6-.7,0-1.2-.3-1.1-1.1.5-2.1,4.4-2.8,4.2-4.2-.2-2.1-2.6-2.4-4.8-2.3,1.6-2.1,4.6-2.2,7-1l4.9-5.5c-3.2-1.9-3.7,2.9-5.3,2.7-.6,0-1.3-1.1-1-1.5l1-1.3c.6-.8-.1-2.7-.9-3l-3-1.1-1.4-1.6c-.3-.3-1.5.4-1.4.7.5,1.8,0,2.5-1.1,3.3-1.2.8-1.9.7-3-.9-.7,2.6-2.6,4-5.1,3.6,4.4-3.4,4-7.5,6.8-4.3.4-1.4.7-2.6,1.7-4.1l-2.4-.5,4.7-2.8c0,1.1-.7,1.9,0,3.1,1.8-.7,1.7-2,2.2-3.9,1.1,2.9,2.5,3.5,5.5,2.9.8-.1,2.9.8,3.1-1.5-1.7.6-3.3.4-4.5-1-.9.3-1.6.6-2.6.4-.7-4.6,5-3.8,3.7-6.5-1.4-2.8-8,.5-12.1,4.6-.6-.3-1-1.1-1-1.5,0-.4-1.1-.6-1.5,0-.3.7.2,1.9-.9,3.1-.8-1.5-1.7-1.1-3.3-1.6,2.7-1.6,3.8-2.2,4.7-5l-2.2-.6c.1-2.4.9-4.5,2.7-6-1.4-.1-2-.7-2.1-1.3,0-.5.4-1.8.2-2.2-1-.6-2.4.2-3.4.4-.4-1.2-3.1-1.8-3.5-.7-.8,2.4-.9,5.2-.9,7.7l1.2,2c.5.8-4,3.2-3.2,6.3,1.5-.9,2.2-.4,2.7,0,1.1,1.1.3,1.5-.7,2-1.8,2.4-.2,5.4,2.4,6.6.4.8-1,2.2-1.9,2.2.4.9.7,1.1,1,1.4.5.5-.4,1-.4,1.3-.7,4-2.8,7.2-5.9,10,1.3,1,1.8,2.1,1.6,3.5-.2,1-1.2,2.5-2.4,2.1-.7-2-2.2-.5-1.2,1,.7.6,2.3.7,2.8,1.9l-3.8,4.3v5.1c-.6,1.3-1.2,2.1-1.2,3.5,0,1.1,3.5,2.7,2.7,9.3l-3.4,2.8c.2,2.1,0,3.8-.4,5.8,1.1.4,1.9.6,2.7,1.4-.5.8-1,2-.7,2.3l1.7,1.4,1.3,6.6c.2.9,2,0,1.6-.7-.3-.6-.3-1.5.1-2.8,1.4,1.5,1.4,3.2.8,4.9,9.7.8,13.1,2.1,30.2-1,.2-.9,0-2.5.3-3.4-4.2,2.1,1.5-3-1.4-6.7ZM91.1,270.3c-.3-.2-.6-1.2-.7-1.9-.1-.6,0-1.6,1.4-1.7.2.9.1,1.5-.7,3.6Z"
      />
      <path
        className="attentive-cls-1"
        d="M48.6,84.5s-6.8-4.7-9.4-6.5c-10.1-7.4-8.6-11.4-10.5-16,0,0-1.1-5.6,5.4-1.4,6.4,4.3,2.5,3.6,6.4,4.3s5.8.9,8.1,2.6,3.9,3.7,4.9,6.2c0,0,5.4,11.1,1.8,11.9-4.4,1.2-6.7-1.1-6.7-1.1Z"
      />
      <path
        className="attentive-cls-1"
        d="M63.9,116.2c.7,4.8-3.3,8.1-7.4,8.7s-6.7-1.7-7.4-6.4c-.7-4.8,3.3-9.2,7.4-9.9s6.7,2.8,7.4,7.6Z"
      />
      <path
        className="attentive-cls-1"
        d="M120.8,113.2c-3.8-3-3-8.2-.4-11.5s6-3.3,9.8-.3,3.8,9,1.2,12.3-6.9,2.5-10.6-.6Z"
      />
      <path
        className="attentive-cls-1"
        d="M140.1,182.1c2.7-4.6,7.7-7.4,12.6-9.3,4.6-2.3,9.2-4.4,14.4-5.2.1,0,.2,0,.3.2-2.2,3.4-5.9,5.9-9.7,7.1,0,0-3.8,1-3.8,1-4.3,1.1-8.5,2.3-11.9,5.3,0,0-1.4,1.3-1.4,1.3-.2.2-.4,0-.3-.3h0Z"
      />
      <path
        className="attentive-cls-1"
        d="M33.9,180.6c4.7-.8,9.2.6,13.3,2.7,4.2,1.7,8.3,3.8,12.2,6,.2.1,0,.4-.2.4-2.2-.6-4.3-1.2-6.5-1.7l-6.5-1.7c-3.3-.7-6.6-1.3-9.5-3.2-1-.6-2-1.3-2.9-2.2-.1-.1,0-.4.1-.4h0Z"
      />
    </g>
  </svg>
);
export default SVGComponent;
